import api from './utils/api';

class UsersService {
  async findById(id) {
    const result = await api.get(`/user/${id}`);

    return result.data;
  }

  async findModelById(id) {
    const result = await api.get(`/models/${id}`);

    return result.data;
  }

  async register({
    email,
    password,
    cpf,
    type,
    phone,
    numberAccept,
    emailAccept,
  }) {
    const result = await api.post('/sign-up', {
      email,
      password,
      type,
      cpf,
      phone,
      numberAccept,
      emailAccept,
    });

    return result.data;
  }

  async login({ email, password, type }) {
    const result = await api.post('/sign-in', { email, password, type });
    return result.data;
  }

  async findByEmail(email) {
    const result = await api.post('/user/email', { email });

    return result.data;
  }

  async listUsers() {
    const result = await api.get('/user');
    return result.data;
  }

  async deleteUser(id) {
    const result = await api.delete(`/user/${id}`);
    return result.data;
  }

  async logout() {
    const result = await api.post('/sign-out');
    return result.data;
  }

  async refreshToken() {
    const result = await api.post('/refresh-token');
    return result.data;
  }

  async forgotPassword(email) {
    const result = await api.post('/forgot-password', { email });
    return result.data;
  }

  async resetPassword(token, password) {
    const result = await api.post('/reset-password', { token, password });
    return result.data;
  }
}

export default new UsersService();
